import React from 'react';
import { Search } from 'lucide-react';

/**
 * Reusable search bar component
 * @param {Object} props
 * @param {string} props.value - Search input value
 * @param {Function} props.onChange - Change handler
 * @param {Function} props.onSubmit - Submit handler
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element}
 */
export const SearchBar = ({ 
  value, 
  onChange, 
  onSubmit, 
  placeholder = 'Search...',
  className = '',
  clearOnEmpty = true,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit((value ?? '').toString());
    }
  };

  const handleChange = (e) => {
    onChange && onChange(e);
    if (clearOnEmpty && (e?.target?.value ?? '').trim() === '') {
      // Trigger submit with empty value so parents can clear applied filters immediately
      onSubmit && onSubmit('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`w-full ${className}`}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
    </form>
  );
}; 